<template>
  <main class="wrapper">
  <app-section-title>
    <h1>Информация о компании</h1>
  </app-section-title>
  <the-info />
    <app-section-title>
      <h1>Почему выбирают нас?</h1>
    </app-section-title>
  <the-slider />
    <app-section-title>
      <h1>Карта сайта</h1>
    </app-section-title>
  <the-cards />
    <app-section-title>
      <h1>Реализованные проекты</h1>
    </app-section-title>
    <the-carousel />
  </main>
</template>

<script>


import TheCards from "@/components/TheCards";
import TheSlider from "@/components/TheSlider";
import TheInfo from "@/components/TheInfo";
import AppSectionTitle from "@/components/AppSectionTitle";
import TheCarousel from "@/components/TheCarousel";

import {ref} from "vue";

export default {
  components: {TheInfo, TheSlider, TheCards, AppSectionTitle, TheCarousel}
}

</script>

<style scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
  }

  h1 {
    font-family: "Poppins", sans-serif ;
    color: #ffd700;
    padding: 20px 80px;
    position: relative;
    font-size: calc( 2.125vw + 15px );
    text-transform: uppercase;
    letter-spacing: 3px;
  }

  @media (max-width: 500px) {
    h1 {
      padding: 10px;
    }
  }

</style>
